import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#111"
      fillRule="evenodd"
      d="M4.719 15.862h1.855v1.754H4.719A2.718 2.718 0 0 1 2 14.897V4.718A2.718 2.718 0 0 1 4.72 2h10.183a2.718 2.718 0 0 1 2.719 2.718v1.845h-1.754V4.718a.965.965 0 0 0-.965-.965H4.72a.965.965 0 0 0-.965.965v10.18c0 .532.432.964.965.964Z"
      clipRule="evenodd"
    />
    <path
      fill="#111"
      fillRule="evenodd"
      d="M6.385 9.103a2.718 2.718 0 0 1 2.718-2.719h10.184a2.718 2.718 0 0 1 2.718 2.719v10.179A2.718 2.718 0 0 1 19.287 22H9.103a2.718 2.718 0 0 1-2.718-2.718V9.102Zm2.718-.965a.965.965 0 0 0-.964.965v10.179c0 .533.431.965.964.965h10.184a.965.965 0 0 0 .964-.965V9.102a.965.965 0 0 0-.964-.964H9.103Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
